import {Spin} from "antd";
import React from "react";

export const PageLoader = ({style, spinStyle, top = 0, bottom = 0, align = "center", width = "100%", height = 200}) => (
    <div style={{display: "flex", justifyContent: "center", alignItems: align, width, height, ...style}}>
        <Spin size="large" style={{marginTop: top, marginBottom: bottom, ...spinStyle}} />
    </div>
);
